import CreatorCoupons from './CreatorCoupons'

export default CreatorCoupons
